<template>
	<div class="processed">
		<!-- <div style="text-align:center;height:100vh;line-height:80vh" v-if="!shophasAuthorization">
			<div style="color:#606266" >{{$t("other.a891")}}
				<router-link style="color:red;text-decoration:none" :to="{name:'index'}">{{$t("other.a892")}}</router-link>
			</div>
		</div> -->
		<div>
			<div style="font-size: 20px;" ><el-button v-show="userPos == 'STORE' || vipLevel === 5 " style="margin-left: 20px;" type="primary" @click="gotopackage()">{{$t("other.a865")}}</el-button></div>
		<div style="margin: 20px 0;display: flex;"  v-for="(item,index01) in buttonList">
				<div >{{item.desc}}</div>
				<span class="filterbox" >
					<span class="storeBox"  :class="{'ttpactive': item.isActive === index }"   v-for="(ttp,index) in item.value" @click="handleBtn(item,ttp.Id,index,index01)">{{ttp.Name}} <span v-show=" index01 !== 0 && userPos == 'SELLER'">({{ttp.num}})</span></span>
					<!-- <el-button v-show="index01 == 0" size="mini" type="primary" @click="init()"> <i class="iconfont  icon-shuaxin2 "></i>重新加载当前面</el-button> -->
				</span>
		</div>
		<div class="block">
		    <span class="demonstration">{{$t("other.a866")}}：</span>
		    <el-date-picker
		      v-model="value9"
		      type="daterange"
			  @change="getValue"
			  value-format="yyyy-MM-dd "
		      :start-placeholder="$t('other.a45')"
		      :end-placeholder="$t('other.a46')"
		      >
		    </el-date-picker>
		  </div>
		<div class="block">
			{{$t("other.a867")}}：
			<el-input
			  style="width: 250px;"
			  :placeholder="$t('other.a868')"
			  @change="getOrderSn()"
			  clearable
			  v-model="req_params.orderId">
			</el-input>
			<el-button style="margin:0 5px" type="primary">{{$t('other.a245')}}</el-button>
		</div>
			<div class="nodata" v-if="amountList.length == 0" >--{{$t('pendingorder.nodata')}}--</div>
			<div  v-else>
				 <el-table
				      :data="amountList"
					  border
				      style="width: 100%;margin-bottom: 50px;">
				      <el-table-column
				        prop="packagedTime"
				        :label="$t('other.a869')"
				        >
				      </el-table-column>
				      <el-table-column
				        prop="amount"
				        :label="$t('other.a870')">
				      </el-table-column>
					  <el-table-column
					    prop="cancelAmount"
					    :label="$t('other.a871')">
					  </el-table-column>
					  <el-table-column
					    prop="shippedAmount"
					    :label="$t('other.a872')">
					  </el-table-column>
					  <el-table-column
					    prop="escrowAmount"
					    :label="$t('other.a77')">
						<template slot-scope="scope">
							<span>{{scope.row.escrowAmount.toFixed(2)}}</span>
						</template>
					  </el-table-column>
					  <el-table-column
					    prop="escrowAmount"
					    :label="userPos == 'SELLER' ? $t('other.a873') : $t('other.a874')">
						<template slot-scope="scope">
							<span>{{scope.row.feeAmount}}</span>
						</template>
					  </el-table-column>
					 <el-table-column
					   :label="$t('other.a33')"
					   width="400"
					   >
					   <template slot-scope="scope">
					   	 <el-button size="mini" type="primary" @click="viesDetail(scope.row)">{{$t('other.a875')}}</el-button>
						 <el-button size="mini"  @click="exportXLMS(scope.row)">{{$t('other.a876')}}</el-button>
						  <el-button size="mini"  @click="pintTrakingOrder(scope.row)">{{$t('other.a877')}}</el-button>
					   </template>
					 </el-table-column>
				    </el-table>
				
			</div>
			
				<!-- 分页器 -->
				<div class="Pager">
					<el-pagination
					style="background-color: #fff;"
					  @size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:current-page="currentPage1"
					:page-sizes="[15, 20, 30, 50]"
					:page-size="offset"
					layout=" total,sizes, prev, pager, next, jumper"
					:total="amountListCount">
					</el-pagination>
				  </div>
			 </div> 
		</div>
		</div>
		
	</div>
</template>

<script>
		import {mapState, mapActions , mapMutations} from 'vuex'
		import api from '../../../api/moudles/processed.js'
		import utils from '../../../utils/utils.js'
	export default{
		data(){
			return {
				req_params:{
					shopIds:null,
					storeIds:null,
					orderId:null,
					offset:15,
					logistics:null,
					page:0,
					start:null,
					end:null,
					platform:'SHOPEE',
					shopIds:JSON.parse(localStorage.getItem('userInfo')).shopeeShops.map(p => {return p.shopId}),
					storeIds:JSON.parse(localStorage.getItem('userInfo')).storeIds,
					userId:JSON.parse(localStorage.getItem('userInfo')).userId

				},
				req_params_copy:{
					shopIds:null,
					storeIds:null,
					offset:15,
					logistics:null,
					page:0,
					start:null,
					end:null,
				},
				buttonList:[],
				options5: [],
				value10: '',
				storeList: [],
				storeValue:'',
				shopIdlist:[],
				warehouse:[],
				currentPage1:1,
				offset:15,
				page:0,
				storeBtn:[],
				processedListCopy:[],
				isactive:[],
				stockList:[],
				isCloundStore:1,
				isActive:true,
				scanNum:'',
				shoplist:[],
				storelist:[],
				storeListCopy:JSON.parse(localStorage.getItem('warehouse')),
				shophasAuthorization:JSON.parse(localStorage.getItem('shophasAuthorization')),
				dialogVisible:false,
				imgUrlList:[],
				shopInfo:[],
				ordersnText:'',
				allShopId:[],
				allStoreId:JSON.parse(localStorage.getItem('userInfo')).storeIds,
				value9: [],
				activeList:[0,0,0]
		
			}
		},
		computed:{
			...mapState({
				userId: state=>state.login.userInfo.userId || '',
				processedList: state=>state.processed.processedList || '',//云仓的订单
				cloudeList: state=>state.processed.cloudeList || '',//测品仓的订单
				country:state=>state.login.userInfo.country || '',
				vipLevel:state=>state.login.userInfo.vipLevel || '',
				userPos: state=>state.login.userInfo.userPos,
				count: state=>state.processed.count,
				logisticsInfo: state=>state.processed.logisticsInfo ,
				amountList: state=>state.processed.amountList ,
				tableList: state=>state.processed.tableList ,
				falg:state=>state.processed.falg ,
				allLogistic:state=>state.processed.allLogistic ,
				amountListCount:state=>state.processed.amountListCount ,
			}),
			
			orderList(){
				if(this.isCloundStore === 1) {
					return this.processedList
				}else{
					return this.cloudeList
				}
			},
			
		
		},
		watch:{
			logisticsInfo(){
				console.log(this.req_params_copy)
				if(this.userPos === 'SELLER'){
					this.req_params_copy.shopIds[0]={
						Id:'',
						Name:this.$t('other.a358')
					}
					this.req_params_copy.storeIds[0]={
						Id:'',
						Name:this.$t('other.a358')
					}
					this.buttonList=[{
						id:0,
						desc:this.$t('other.a359')+'：',
						isActive:this.activeList[0],
						value:this.req_params_copy.shopIds,
					},
					{
						id:2,
						desc:this.$t('other.a878'),
						isActive:this.activeList[1],
						value:this.logisticsInfo,
					}]
					console.log(this.req_params)
					this.getProcessedOrders(this.req_params)
				}else{
					
					this.req_params_copy.storeIds[0]={
						Id:'',
						Name:this.$t('other.a358')
					}
					this.buttonList=[{
						id:0,
						desc:this.$t('other.a653')+'：',
						isActive:this.activeList[0],
						value:this.req_params_copy.storeIds,
					},
					{
						id:2,
						desc:this.$t('other.a878'),
						isActive:this.activeList[1],
						value:this.logisticsInfo,
					},{
						id:3,
						desc:this.$t('other.a879')+'：',
						isActive:this.activeList[2],
						value:JSON.parse(localStorage.getItem('userInfo')).sellers.map(p => {return {
							Id:p.userId,
							Name:p.userName,
						}})
					}]

					this.buttonList[2].value[0]={
						    Id:'all',
							Name:this.$t('other.a358'),
							isActive:this.isActive[2]
					}
					console.log('store',this.buttonList)
					this.getProcessedOrders(this.req_params)
				}
					
			},
			falg(){
				if(this.falg){
					utils.cleanStorageData()
					let obj={
						list:this.tableList,
						shopInfo:this.shopInfo
					}
					localStorage.setItem('tableList',JSON.stringify(obj))
					
					let router = this.$router.resolve(
					  { 
					    name: "processedDetail" ,
					  }
					);
					window.open(router.href, '_blank');
				}
			},
			ordersnText(){
				if(this.ordersnText == ''){
					this.init()
				}
			}
		},
		created(){
			this.init()
		},
		methods:{
			...mapActions('processed',[
				'getProcessedOrderSn',
				'getProcessedOrderInfo',
				'getIDacountProcessedList',
				'getPackagedOrderByStore',//仓库帐号下猎取已出库出库的订单
				'setPackaged',
				'getProcessedOrders',
				'getProcessedOrdersByStore',
				'getLogisticsBystore',
				'getLogisticsByseller',
				'getProcessedOrderBySeller',
				'getProcessedOrderByStore',
				'getOrderByOrderId'
			]),
			
			...mapActions('print',[
			   'getParams',
			   'getAllOrders',
			   'getStoreOrders',
						   
			]),
		
			
			...mapMutations('processed',[
				'SET_PROCESSED_ORDER_LIST',
				'SET_INTN'
			]),
			
			
			
			
			getValue(){
				console.log(this.value9)
				this.req_params.start=this.value9[0]
				this.req_params.end=this.value9[1]
				this.req_params.packageTime=null
				console.log(this.req_params)
				this.getProcessedOrders(this.req_params)
				
				
			},
			
			showShopName(id){
				let ccp=null
				if(this.userPos === 'SELLER'){
					ccp=utils.showshopNameByshopId()
					return ccp[id]
				}else if(this.userPos === 'STORE'){
					ccp=utils.showstoreNameBystoreId(id) 
					return ccp
				}
				
				
			},
			
			
			getOrderSn(){
				this.getProcessedOrders(this.req_params)
			},
			
			
			gotopackage(){
				let shopeePlatform=true
				localStorage.setItem('shopee',JSON.stringify(shopeePlatform))
				let router = this.$router.resolve(
				  { 
				    name: "package" ,
				  }
				);
				
				window.open(router.href, '_blank');
			},
			viesDetail(params){
				console.log(params)
				this.shopInfo=params
				let ccp=this.req_params
				let obj=new Object()
				if(this.userPos === 'SELLER'){
					ccp.shopIds=this.req_params.shopIds
					
					ccp.packageTime=params.packagedTime
					this.getProcessedOrderBySeller(ccp)
				}else if(this.userPos === 'STORE') {
					ccp.shopIds=this.req_params.shopIds
					ccp.packageTime=params.packagedTime
					this.getProcessedOrderBySeller(ccp)
				}
			},
			
			exportXLMS(params){
				
				console.log(params)
				this.req_params.packageTime=params.packagedTime
				
				
				// api
				// .getProcessedOrderBySeller(this.req_params)
				// .then(res => {
				// 	if (res.code === 200) {
				// 		console.log('卖家获取所有已处理的订单',res.data)
						
				// 		let list=['Date','OrderID','Sku_Qty','Integral','Shop']
				// 		let arr=[]
				// 		res.data.forEach(p => {
							
				// 				arr.push({
				// 					'Date':params.packagedTime,
				// 					'OrderID':p.orderId,
				// 					'Sku_Qty':p.items.length,
				// 					'Integral':p.fee,
				// 					'Shop':p.userId
									
									
									
				// 				})
							
				// 		})
				// 		console.log(arr)
				// 		utils.exPortEXml(arr,list,'processedOrder')
				// 	}
				// })
			},
			pintTrakingOrder(params){
				let ccp=this.req_params
				
				ccp.packageTime=params.packagedTime
				api
				.getProcessedOrderBySeller(ccp)
				.then(res => {
					if (res.code === 200) {
						console.log('卖家获取所有已处理的订单',res.data)
						// localStorage.setItem('signorder', JSON.stringify(res.data))
						// const {href}=this.$router.resolve({
						// 	name:'signOrder',
						
						// }) 
						// window.open(href)
					}
				})
			},
			
			
			
			//扫描枪调用的方法
			packBageOut(){
				if(this.scanNum){
					this.setPackaged({orderId:this.scanNum})
				}else{
					
					return
				}
			},
			
			
			
			handleBtn(item,value,index,index01){
				console.log(item)
				console.log(value)
				console.log(index)
				console.log(index01)
			if(index01 == 0){
				this.activeList[0]=index
			}else if(index01 == 1){
				this.activeList[1]=index
			}else if(index01 == 2){
				this.activeList[2]=index
				let list=JSON.parse(localStorage.getItem('userInfo')).sellers
				let list2=[]
				console.log('list',list)
				if(value == 'all'){
					list.forEach(p => {
						if(p.shopeeShops !== null){
							p.shopeeShops.forEach(k => {
							list2.push(k.shopId)
						})
						}
						
					})
				}else{
					list.forEach(p => {
						if(p.userId == value){
							if(p.shopeeShops !== null){
								p.shopeeShops.forEach(k => {
							     list2.push(k.shopId)
								})
							}
							
					
						}
						
					})
				}
				this.req_params.shopIds=list2
				console.log('list2',list2)
			}

				this.buttonList.forEach(p => {
					p.value.forEach((k,index) => {
						if(value === k.Id && p.id === item.id){
							p.isActive=index
						}
					})
				})
				if(this.userPos == 'SELLER'){
				
					if(item.id == 0){
						value === '' ? this.req_params.shopIds=this.allShopId : this.req_params.shopIds=[value]
					}else if(item.id == 2){
						value === '' ? this.req_params.logistics=this.allLogistic : this.req_params.logistics=value
						
					}
					this.req_params.packageTime=null
					console.log(this.req_params)
					this.getLogisticsByseller(this.req_params)
				}else if(this.userPos === 'STORE'){

					if(item.id == 2) {
						console.log(777)
						value === '' ? this.req_params.logistics=this.allLogistic : this.req_params.logistics=value
					}

				     if(this.req_params.shopIds.length ==0){
						this.SET_INTN()
						return
					 }
					this.req_params.packageTime=null
					console.log(this.req_params)
					this.getLogisticsBystore(this.req_params)
				}
			},
		
			init(){ 
				// if(!this.shophasAuthorization){
				// 	return
				// }
				this.value9[0]=utils.getRecentSevenDay(-7)
				this.value9[1]=utils.getRecentSevenDay(1)
				this.req_params.start=this.value9[0]
				this.req_params.end=this.value9[1]
				
				if(this.userPos === 'STORE'){
				this.req_params.storeIds=utils.getAllwarehouse().map(p => {return {Name:p.label,Id:p.value}})
				this.req_params_copy.storeIds=utils.getAllwarehouse().map(p => {return {Name:p.label,Id:p.value}})
				this.allStoreId=utils.getAllwarehouse().map(p => {return p.value}).slice(1)
				this.req_params.storeIds=this.allStoreId
				this.getLogisticsBystore(this.req_params)
				
			
					
				}else if(this.userPos === 'SELLER'){
					this.req_params.shopIds=utils.getAllshop().map(p => {return p.value}).slice(1)
					this.req_params_copy.shopIds=utils.getAllshop().map(p => {return {Name:p.label,Id:p.value}})
					this.req_params_copy.storeIds=utils.getAllwarehouse().map(p => {return {Name:p.label,Id:p.value}})
					this.allShopId=utils.getAllshop().map(p => {return p.value}).slice(1)
					console.log(this.req_params)
					this.getLogisticsByseller(this.req_params)
					
				}
			},
			handleSizeChange(val) {
				this.offset=Number(`${val}`)
				console.log(this.offset);
				this.req_params.offset=this.offset
				this.getProcessedOrders(this.req_params)
			 },
			handleCurrentChange(val) {
				this.page=this.offset*(Number(`${val}`) -1)
				console.log(this.page)
				this.req_params.page=this.page
				this.getProcessedOrders(this.req_params)
			},
			
		}
	}
</script>

<style>
	.processed{
		flex: 1;
		
	}
	
	.processed .block{
		display: flex;
		align-items: center;
		margin-bottom: 20px;
	}
	.processed .order-list-item {
			position: relative;
			padding-bottom: 10px;
			box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
		}

		.processed .order-query {
			display: flex;
			justify-content: start;
		
			padding: 10px 10px 10px 0;
			border-bottom: 1px #E0E0E0 solid;
		}

		img {
			width: 100%;
		}

		.processed .nodata{
			margin-top: 100px;
			text-align: center;
			color: #000;
		}
		

		.processed .Pager{
			float: right;
			
		}

		.processed  .el-dropdown-link{
			color: #606266;
		}
	/* 新起点 */
	
  .list-desc{
	  padding: 10px 15px;
  }
	
	.processed .chekbox{
		width: 30px;
		height: 30px;
		line-height: 30px;
	}
	
	.processed .pic-box{
			display: flex;
		    margin: 2px;
			width: 80px;
			height: 80px;
	}
	.processed .return-item{
		display: flex;
		justify-content: space-between;
		box-sizing: border-box;
		padding: 1px;
	}
	
	.processed .storeBox{
		border: 1px solid #eee;
		box-sizing: border-box;
		padding: 5px;
		font-size: 14px;
		cursor: pointer;
		margin:0 2px;
		
	}

	.processed .storeBox:hover{
		color: #1890ff;
	}
	.processed .return-item-list{
		display: flex;
		align-items: center;
	
	}
	
	.processed .unfold:nth-of-type(n+4){
		display: none;
		
	}
	
	.processed .pic-box-desc{
		width: 350px;
		margin-left: 20px;
	}
	.processed .retrun-reasonr{
		margin-left: 30px;
	}
	.processed .retrun-reasonr-btn{
		display: flex;
		flex-direction: column;
		align-items: center ;
		margin-right: 20px;
	}
	.processed .seller{
		margin-right: 10px;
		font-size: 18px;
	}
	.processed .return-reasonr-desc{
		box-sizing: border-box;
		padding: 3px 0;
	}
	
	
	
	.processed  .ttpactive{
		background-color: #1890ff;
		color: #fff;
	}
	.processed  .ttpactive:hover{
		background-color: #40a9ff;
		color: #fff;
	}
	
	.IdScaneArea .el-input__inner{
		width: 99%;
		height: 130px;
		font-size: 30px;
		margin-top:20px
		
	}
	
	.pic-box{
		width: 80px;
		height: 80px;
	}
	
/* 	.chooseall{
		margin-left: 15px;
		font-size: 12px;
		cursor: pointer;
		color: #40a9ff;
		padding: 0 10px;
		border: 1px #40a9ff solid;
	} */

	
.filterbox {
    display: flex;
    flex-wrap: wrap;
	flex: 1;
}

.refresh{
	color: #409EFF;
	font-size: 20px;
	padding: 10px;
}

.processed .Pager{
		position: fixed;
		bottom: 0;
		left: 235px;
		right: 0;
		height: 40px;
		line-height: 40px;
		background-color: #fff;
		text-align:right;
	}
	
	
	
</style>
